import React from 'react';
import './WorkshopMobileToggle.css';

export function WorkshopMobileToggle({ views, activeView, onViewChange }) {
  return (
    <div className="workshop-mobile-toggle" role="tablist">
      {views.map(view => (
        <button
          key={view.id}
          className={`workshop-toggle-segment ${activeView === view.id ? 'active' : ''}`}
          onClick={() => onViewChange(view.id)}
          role="tab"
          aria-selected={activeView === view.id}
          style={{ touchAction: 'manipulation' }}
        >
          {view.label}
        </button>
      ))}
    </div>
  );
}
